import { render, staticRenderFns } from "./_role.vue?vue&type=template&id=5eee7dff&lang=pug&"
import script from "./_role.vue?vue&type=script&lang=js&"
export * from "./_role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports